/**
 * Created by Viacheslav Stepanian on 13.04.2026.
 */

const QuestsWindow = Prefab.createWindow("quests_window", "quests_window_prefab_json", {
    bundles: () => {
        const config = cleverapps.achievements && AchievementsConfig.listByExpedition(cleverapps.meta.selectedLocationId())[0];
        if (config && Families[config.code]) {
            return Families.listLazyBundles(config);
        }
        return config ? ["achievementswindow", "achievements"] : [];
    }
});

QuestsWindow.IsAvailable = function () {
    return cleverapps.meta.getSelectedLocation().locationConfig.hasQuestsWindow;
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    QUESTWINDOW_REWARD_TEXT: {
        name: "nostroke",
        color: new cc.Color(168, 66, 38),
        size: 40
    }
});
